module.exports = __webpack_public_path__ + "static/media/finAssistant.b022bf30.png";